module.exports = __webpack_public_path__ + "static/img/areaA-8.fb46fe7.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character1/ワンダーエージェント_イラスト/areaA-8.png
// module id = 946
// module chunks = 1